import React from 'react';

import { Flex, FlexProps, Space, Text, Title, useMantineTheme } from '@mantine/core';
import { IconSearch } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

interface NoDataFoundProps extends FlexProps {
  icon?: React.ReactNode;
  title?: string;
  subTitle?: string;
  button?: React.ReactNode;
  size?: 'xs' | 'sm' | 'md';
  transparentIconBackground?: boolean;
}

export function NoDataFound({
  icon,
  title,
  subTitle,
  button,
  size = 'sm',
  transparentIconBackground = false,
  ...flexProps
}: NoDataFoundProps) {
  const theme = useMantineTheme();
  const { t } = useTranslation();

  const order = size === 'xs' ? 4 : size === 'sm' ? 3 : 2;

  return (
    <Flex align="center" justify="center" direction="column" h="100%" {...flexProps}>
      <Flex direction="column" align="center" justify="center" maw={300}>
        <Flex
          p={size}
          direction="column"
          align="center"
          justify="center"
          style={{
            backgroundColor: transparentIconBackground ? 'transparent' : theme.other.gray.bg,
            borderRadius: 10
          }}>
          {icon ?? <IconSearch size={48} />}
        </Flex>

        <Space h={10} />
        <Title align="center" order={order} style={{ marginBottom: 10 }}>
          {title ?? t('NO_DATA_FOUND.SEARCH')}
        </Title>
        <Text align="center" maw={`80%`} color="dimmed">
          {subTitle}
        </Text>
        <Space h={20} />
        {button}
      </Flex>
    </Flex>
  );
}
